import React from 'react';
import './style.scss';
import { RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import clsx from 'clsx';
import GenericPlaceholder from '../Shared/components/GenericPlaceholder/index.js';

const CardsTable = (props) => {
  if (!props?.fields || !props.params) {
    return <GenericPlaceholder componentName="CardsTable" />;
  }
  const { title, items } = props?.fields;
  const { Styles } = props.params;

  return (
    <div className={clsx('cards-table', 'add-margins', Styles)}>
      {title && (
        <div className="cards-table-heading">
          <Text field={title} />
        </div>
      )}
      {items?.length > 0 && (
        <div className="cards-table-description">
          {items.map((item, index) => (
            <DescriptionItem data={item} key={index} />
          ))}
        </div>
      )}
    </div>
  );
};

const DescriptionItem = ({ data }) => {
  const { heading, text } = data.fields;

  return (
    <div className="cards-table-desc-item">
      {heading?.value && (
        <div className="ctd-item-heading">
          <Text field={heading} />
        </div>
      )}
      {text?.value && (
        <div className="ctd-item-text">
          <RichText field={text} />
        </div>
      )}
    </div>
  );
};

export default CardsTable;
